module.exports = __webpack_public_path__ + "img/shows.200c9cb4.svg";